import { createFileRoute } from "@tanstack/react-router";

import { QueryConsoleErrorBoundary } from "@/features/search-ops/query-console-error-boundary";
import { QueryConsolePanel } from "@/features/search-ops/query-console-panel";

export const Route = createFileRoute("/_authenticated/search/query-console")({
  component: QueryConsoleRoute,
});

function QueryConsoleRoute() {
  return (
    <QueryConsoleErrorBoundary>
      <div className="flex min-h-0 flex-1 flex-col">
        <QueryConsolePanel />
      </div>
    </QueryConsoleErrorBoundary>
  );
}
